import { render, staticRenderFns } from "./JoinedMembers.vue?vue&type=template&id=535476ce&scoped=true&"
import script from "./JoinedMembers.vue?vue&type=script&lang=js&"
export * from "./JoinedMembers.vue?vue&type=script&lang=js&"
import style0 from "./JoinedMembers.vue?vue&type=style&index=0&id=535476ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535476ce",
  null
  
)

export default component.exports